import { Component, OnInit } from '@angular/core';
import { MessengerService } from '@services/messenger/messenger.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-page-not-auth',
    templateUrl: './page-not-auth.component.html',
    styleUrls: ['./page-not-auth.component.scss'],
    standalone: false
})
export class PageNotAuthComponent implements OnInit {

  public supportMail = 'support@ipeak.ch';

  constructor(private ms: MessengerService, private router: Router) {
  }

  ngOnInit() {
  }

}
